import type { CommandeRow } from '../../types/commande.types';
import { formatDossierDate } from '../../utils/dossierFormat';
import {
  $Card,
  $CardStack,
  $CardTopRow,
  $MetaItem,
  $MetaValue,
} from '../DossierCardList/DossierCardList.styles';

export interface CommandeCardProps {
  commande: CommandeRow;
}

const CommandeCard = ({ commande }: CommandeCardProps) => {
  const clientName = `${commande.clientPrenom} ${commande.clientNom}`.trim();

  return (
    <$Card data-testid={`commandes-card-${commande.numeroCommande}`}>
      <$CardStack>
        <$CardTopRow>
          <$MetaItem>
            <$MetaValue>{commande.numeroCommande}</$MetaValue>
          </$MetaItem>
          <$MetaItem $alignEnd>
            <$MetaValue>{formatDossierDate(commande.dateAchat)}</$MetaValue>
          </$MetaItem>
        </$CardTopRow>
        <$MetaItem>
          <$MetaValue>{commande.nombreProduits}</$MetaValue>
        </$MetaItem>
        <$MetaItem>
          <$MetaValue>{clientName}</$MetaValue>
        </$MetaItem>
      </$CardStack>
    </$Card>
  );
};

export default CommandeCard;
